import http from "@/http/aisea/axios";
const resource = "/account/admin/login";
const ssoResource = "/account/sso";

export default {
  loginWithEnterprise(payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/enterprise`, payload, {
      headers: headers,
    });
  },
  mfaWithEnterprise(payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/enterprise/mfa`, payload, {
      headers: headers,
    });
  },
  mfaResend(payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/enterprise/mfa_resend`, payload, {
      headers: headers,
    });
  },
  loginMarina(payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/marina`, payload, {
      headers: headers,
    });
  },
  loginPersonal(payload, headers) {
    //Repository.defaults.headers.post['Content-Type'] = 'multipart/form-data'
    return http.post(`${resource}/personal`, payload, {
      headers: headers,
    });
  },
  loginProject(payload, headers) {
    return http.post(`${resource}/project`, payload, {
      headers: headers,
    });
  },
  logout() {
    return http.delete(`/account/admin/logout`);
  },
  getSsoToken(accountId, enterpriseManningVesselId) {
    return http.get(`${ssoResource}/token`, {
      params: {
        account_id: accountId,
        payload: `{ "enterprise_manning_vessel_id": "${enterpriseManningVesselId}"}`,
      },
    });
  },
};
